<style scoped>
  .rodape { font-size: .9rem; }
  img { width: 20% }
</style>

<template>
  <footer class="rodape b-t m-t-lg animated fadeIn" v-if="estaLogado">
    <div class="container">
      <div class="columns">

        <div class="column m-sm ">
          Portal de vendas <br/>
          <small><b>{{nome}}</b> - Versão: {{ versao }}</small>
        </div>

        <div class="column m-sm has-text-centered">
          <img src="../assets/images/logobin3.png" />
        </div>

        <div class="column m-sm has-text-right">
          <b>Bin</b> Gestão de TI & Negócios<br/>
          <small>Desenvolvido para agilizar a implantação de pedidos</small>
        </div>

      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    created () {
      this.$root.$on('acessar', () => {
        this.usuario = this.$air.usuarioLogado()
      })
      this.usuario = this.$air.usuarioLogado()
    },
    data () {
      return { usuario: {} }
    },
    computed: {
      estaLogado () {
        return (this.usuario !== undefined && this.usuario !== null && this.usuario.token !== null && this.usuario.token !== undefined)
      },
      nome () {
        return this.$sistema.nome()
      },
      versao () {
        return this.$sistema.versao()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PortalRodape.vue